class Collection {

  constructor () {
    this.elements = []
  }

  add = (item) => this.elements.push(item)
  getAll = () => this.elements
  clear = () => this.elements = []

  static create = () => {
    return new Collection()
  }
}

export default Collection